import React, { useContext, useEffect, useState } from "react"
import { TopMenu } from "../components/TopMenu.jsx"
import { GlobalStateContext } from "../components/providers/GlobalStateProvider.jsx"
import { useNavigate } from "react-router-dom"
import { UpgradeBasicModal } from "../components/upgradebasic/UpgradeBasicModal.jsx"
import { KopyBasicUpgradeCards } from "../components/upgradebasic/KopyBasicUpgradeCards.jsx"
import { usePostHog } from "posthog-js/react"

const UpgradeBasic = () => {
	const posthog = usePostHog()
	const { state } = useContext(GlobalStateContext)
	const navigate = useNavigate()
	const [upgradeModalIsOpen, setUpgradeModalIsOpen] = useState(false)

	const openUpgradeModal = () => {
		setUpgradeModalIsOpen(true)
	}

	useEffect(() => {
		if (state.hasValidKopyBasicSubscription) {
			navigate("/")
		} else {
			posthog?.capture("user_visits_upgrade_basic_page_v2")
		}
	}, [state.kopyBasicSubscription])

	return (
		<div>
			<TopMenu goBack="/" storeSelector />

			<div
				style={{
					height: "100%",
					padding: "1rem",
					paddingTop: "5rem",
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					justifyContent: "center",
					gap: "1rem",
				}}
			>
				<KopyBasicUpgradeCards onUpgradeClick={openUpgradeModal} />
			</div>

			<UpgradeBasicModal
				open={upgradeModalIsOpen}
				setOpen={setUpgradeModalIsOpen}
			/>
		</div>
	)
}

export default UpgradeBasic
